export const getCalles = () => {
  return fetch("http://190.64.112.204:5000/calles", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    mode: "cors",
    cache: "default",
  })
    .then((result) => {
      return result.json();
    })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      // console.log(err);
    });
};

//190.64.112.204
export const getLatLng = (calle, numero) => {
  return fetch(`http://190.64.112.204:5000/geodom?idCalle=${calle}&nroPuerta=${numero}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    mode: "cors",
    cache: "default",
  })
    .then((result) => {
      return result.json();
    })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      // console.log(err);
    });
};


export const calculatePrice = (lat1, lng1, lat2, lng2) => {
  return fetch(`http://190.64.112.204:5000/calculo?LatIni=${lat1}&LonIni=${lng1}&LatFin=${lat2}&LonFin=${lng2}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    mode: "cors",
    cache: "default",
  })
  .then((result) => {
    return result.json();
  })
  .then((result) => {
      return result;
    })
    .catch((err) => {
      // console.log(err);
    });
};
